module.exports = __webpack_public_path__ + "assets/backArrow.732633f8.svg";